import { InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Customer } from '../Customer'

@InputType()
export class GetMyCustomerArgs extends ActionArgs {}

export interface IGetMyCustomer extends IAction<Customer, GetMyCustomerArgs> {}
